// PreventiApp — Gestor de consentimiento de cookies (Chile · Ley 21.719).
//
// Estados guardados en localStorage bajo `preventiapp_consent_v1`:
//   { status: 'accepted' | 'essentials-only' | null,
//     analytics: boolean,
//     marketing: boolean,
//     ts: string (ISO) }
//
// Reglas:
//   • Cookies esenciales (funcionamiento del sitio, preferencias UI): SIEMPRE OK.
//   • Cookies de analítica / marketing (GTM, pixels): sólo si `analytics=true`.
//   • Sin decisión → NO se cargan trackers.

const KEY = 'preventiapp_consent_v1';

export const CONSENT_EVENT = 'preventi:consent-change';

export function readConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) { return null; }
}

export function writeConsent(payload) {
  const record = { ...payload, ts: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(record));
  try {
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: record }));
  } catch (_) { /* no-op */ }
  return record;
}

export function acceptAll() {
  return writeConsent({ status: 'accepted', analytics: true, marketing: true });
}

export function acceptEssentialsOnly() {
  return writeConsent({ status: 'essentials-only', analytics: false, marketing: false });
}

export function acceptCustom({ analytics = false, marketing = false }) {
  return writeConsent({ status: 'accepted', analytics: !!analytics, marketing: !!marketing });
}

export function hasAnalyticsConsent() {
  const c = readConsent();
  return !!(c && c.analytics === true);
}

export function needsDecision() {
  const c = readConsent();
  return !c || !c.status;
}
